var CommunityRegionPage;
(function (CommunityRegionPage) {
    function loadListings(regionId, showDetails) {
        var addrTitle, addrWidth;
        if (showDetails) {
            addrTitle = "Address";
            addrWidth = "300px";
        }
        else {
            addrTitle = "Suburb";
            addrWidth = "150px";
        }
        var fullCount = -1;
        $('#listings').DataTable({
            scrollX: true,
            lengthChange: false,
            ordering: false,
            info: true,
            searching: true,
            paging: true,
            pageLength: 20,
            pagingType: "full_numbers",
            processing: true,
            serverSide: true,
            searchDelay: 1500,
            stateSave: false,
            language: {
                emptyTable: "No locations",
                zeroRecords: "No matching locations"
            },
            columns: [
                { title: "Organisation", width: '300px' },
                { title: addrTitle, width: addrWidth },
                { title: "Contact", width: '100px', className: "centered" },
                { title: "Services", width: '400px' },
                { title: "Description", width: '800px' },
            ],
            ajax: function (data, callback, settings) {
                var s = data.search.value || "-";
                var p = (data.start / 20) + 1;
                $.getJSON("/api/search/regional/" + regionId + "/" + s + "/" + p + "/" + data.draw, function (d) {
                    if (fullCount === -1) {
                        fullCount = d.Total;
                    }
                    var a = { data: [], recordsTotal: fullCount, recordsFiltered: d.Total };
                    d.Results.forEach(function (item) {
                        var services = "";
                        item.SubResults.forEach(function (service) {
                            services = services + "<a href='" + service.Url + "'>" + service.Category.Name + "</a><br/>";
                        });
                        var phone, addr;
                        if (showDetails) {
                            phone = item.Outlet.Phone || "";
                            var pstripped = phone.replace(/[^0-9]+/g, "");
                            if (pstripped.length === 0) {
                                phone = "";
                            }
                            else {
                                phone = "<a href='tel:" + pstripped + "'>" + phone + "</a>";
                            }
                            addr = item.Outlet.DisplayAddress;
                        }
                        else {
                            phone = "<a href='" + item.Url + "' class='btn btn-small btn-blue'>Contact Us</a>";
                            addr = item.Outlet.Suburb;
                        }
                        a.data.push([
                            "<a href='" + item.Url + "'>" + item.Outlet.Nickname + "</a>",
                            addr,
                            phone,
                            services,
                            item.Description
                        ]);
                    });
                    callback(a);
                });
            }
        }).on('processing.dt', function (e, settings, processing) {
            if (processing) {
                Page.ShowThinking("#listings_processing");
            }
        });
        $("#listings-container input[type=search]").attr("aria-label", "Type to filter listings with matching search terms");
    }
    function Init(communityRegionID, userHasAccessToDetails, showListings, mapModel) {
        $(function () {
            Common.InitEmail(function (d) {
                return {
                    OutletID: d.data("outlet"),
                    OutletServiceID: d.data("service"),
                    CategoryID: d.data("category"),
                    CouncilRegionID: d.data("region"),
                    FromName: $("#txt-name").val(),
                    FromEmail: $("#txt-email").val(),
                    Phone: $("#txt-phone").val(),
                    Message: $("#txt-enquiry").val()
                };
            });
            Common.LoadPromotions();
            if (showListings) {
                loadListings(communityRegionID, userHasAccessToDetails);
            }
            if (mapModel.Loaded) {
                var map;
                var boundaryLayer;
                function showMap() {
                    var mapOptions = {
                        center: new google.maps.LatLng(mapModel.CentralLatitude, mapModel.CentralLongitude),
                        zoom: 12,
                        mapTypeId: google.maps.MapTypeId.ROADMAP
                    };
                    map = new google.maps.Map(document.getElementById('map_canvas'), mapOptions);
                    boundaryLayer = new google.maps.KmlLayer({ url: mapModel.KmlLocation + "?x=0" });
                    boundaryLayer.setMap(map);
                }
                google.maps.event.addDomListener(window, 'load', showMap);
            }
        });
    }
    CommunityRegionPage.Init = Init;
})(CommunityRegionPage || (CommunityRegionPage = {}));
